import { useState } from "react";
import { useParams } from "react-router";

import { CardAttributeCopyForm } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/components/forms/CardAttributeCopyForm";
import { ActionBar } from "../../../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../../../../../components/FeatureButtons/SubmitButton";
import { ResourceName } from "../../../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../../../core/router/types/routerTypes";

export const CardAttributeCopyFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const { cardImplementationId, cardDefinitionId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${FORM_ACTION.EDIT}/${cardDefinitionId}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardAttributesCopyFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={backUrl} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardAttributeCopyForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
